"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const components_1 = require("@/services/components");
const associatedComponents_1 = require("@/store/ducks/associatedComponents");
const products_1 = require("@/store/ducks/products");
function removeProductAssociation(componentId, productId) {
    return async (dispatch) => {
        dispatch((0, associatedComponents_1.deleteAssociation)());
        try {
            await (0, components_1.associateProductToComponent)(componentId, {
                add: [],
                remove: [productId],
            });
            dispatch((0, associatedComponents_1.deleteAssociationSuccess)());
            dispatch((0, associatedComponents_1.closeDeleteAssociationModal)());
            dispatch((0, products_1.openProductsToast)({ status: "success", message: "Component deleted" }));
        }
        catch (e) {
            dispatch((0, associatedComponents_1.deleteAssociationError)());
            dispatch((0, products_1.openProductsToast)({ status: "error", message: "Error deleting component" }));
        }
    };
}
exports.default = removeProductAssociation;
